import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from 'exceljs';
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useDispatch } from "react-redux";

function flattenObject(obj, parentKey = "", result = {}) {
  for (let key in obj) {
    if (
      typeof obj[key] === "object" &&
      !Array?.isArray(obj[key]) &&
      obj[key] !== null
    ) {
      flattenObject(obj[key], `${parentKey}${key}.`, result); // Recursive call for nested objects
    } else {
      result[`${parentKey}${key}`] = obj[key]; // Add the value to the result
    }
  }
  return result;
}

export const handleExport = async (
  selectionModel,
  nameofFile,
  unsettledListlist,
  check,
  visibleColumns,
  columns
) => {
  const safeRows = Array.isArray(unsettledListlist) ? unsettledListlist : [];
  const hasSelection = Array.isArray(selectionModel) && selectionModel.length;
  const selectedRows = hasSelection
    ? safeRows.filter((row) => selectionModel.includes(row.id))
    : safeRows;

  let exportData = [];
  if (check === "isDisabled") {
    exportData = selectedRows?.filter((data) => data.isDisabled === false);
  }
  if (check === "isActive") {
    exportData = selectedRows?.filter((data) => data.isActive === "Y");
  }

  if (exportData.length > 0) {
    const filteredData = exportData.map((row) => {
      const flattenedRow = flattenObject(row);

      // Remove any field you want to exclude before filtering (like 'check')
      delete flattenedRow["check"];

      const columnKeys =
        Array.isArray(visibleColumns) && visibleColumns.length
          ? visibleColumns
          : Object.keys(flattenedRow);

      const filteredRow = Object.keys(flattenedRow)
        .filter((key) => columnKeys.includes(key))
        .reduce((acc, key) => {
          acc[key] = flattenedRow[key];
          return acc;
        }, {});
      return filteredRow;
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SelectedData");

    // Add header row
    const headerRow = worksheet.addRow(Object.keys(filteredData[0]));
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF00" }, // Yellow
      };
      cell.font = { bold: true };
    });

    // Add rows
    filteredData.forEach((row) => {
      worksheet.addRow(Object.values(row));
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${nameofFile}.xlsx`);
  } else {
    console.warn("No data to export.");
  }
};

export const handleExportOrg = async (
  selectionModel,
  nameofFile,
  unsettledListlist,
  check,
  visibleColumns,
  columns
) => {
  const selectedRows = unsettledListlist.filter((row) =>
    selectionModel.includes(row.id)
  );

  let exportData = [];
  if (check === "isDisabled") {
    exportData = selectedRows?.filter((data) => data.isDisabled === false);
  } else if (check === "isActive") {
    exportData = selectedRows?.filter((data) => data.isActive === "Y");
  }

  if (exportData.length > 0) {
    const filteredData = exportData.map((row) => {
      const flattenedRow = flattenObject(row);
      delete flattenedRow["check"]; // Exclude the 'check' field

      const filteredRow = Object.keys(flattenedRow)
        .filter((key) => visibleColumns?.includes(key))
        .reduce((acc, key) => {
          acc[key] = flattenedRow[key];
          return acc;
        }, {});

      // Add dynamic columns based on column definitions
      visibleColumns.forEach((columnField) => {
        const columnDef = columns.find((col) => col.field === columnField);
        if (!columnDef) return;

        if (columnDef.field === "owners.phone") {
          filteredRow[columnDef.headerName] = row.owners
            ?.map((owner) => owner.phone)
            .join(", ");
        } else if (columnDef.field === "owners.firstName") {
          filteredRow[columnDef.headerName] = row.owners
            ?.map((owner) => owner.firstName)
            .join(", ");
        } else if (columnDef.field && row[columnDef.field] !== undefined) {
          filteredRow[columnDef.headerName] = row[columnDef.field];
        }
      });

      return filteredRow;
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("SelectedData");

    // Add header row with yellow background
    const headers = Object.keys(filteredData[0]);
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF00" }, // Yellow
      };
      cell.font = { bold: true };
    });

    // Add data rows
    filteredData.forEach((dataRow) => {
      worksheet.addRow(Object.values(dataRow));
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${nameofFile}.xlsx`);
  } else {
    console.warn("No data to export.");
  }
};
